function customizeShopifyForm() {
  const embed = document.querySelector('shopify-forms-embed');
  const form = embed?.shadowRoot?.querySelector('form[data-testid="form"]');

  if (!form) return false;

  form.style.setProperty('padding', '0 4px', 'important');

  return true;
}

const observer = new MutationObserver(() => {
  if (customizeShopifyForm()) {
    observer.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

customizeShopifyForm();